import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {GoogleLoginProvider, SocialUser} from "angularx-social-login";
import {NGXLogger} from "ngx-logger";

@Injectable({
    providedIn: 'root'
})
export class OAuthUserServiceService {

    private log_prefix=this.constructor.name;
    private oauth_user_login_state:boolean = false;
    private socialUser:SocialUser;
    constructor(private logger:NGXLogger) {
    }

    public getOAuthUserLoginState(){
        return this.oauth_user_login_state;
    }
    public getCurrentOAuthUserSessionState():Observable<boolean>{
        return new Observable((observer)=>{
            return observer.next(this.oauth_user_login_state);
        })
    }
    public updateOAuthSessionState(user: SocialUser):Observable<boolean>{
        let lp = this.log_prefix+"updateOAuthSessionState:";
        this.socialUser = user;
        let test = (this.socialUser != null);
        if(test == true){
            this.oauth_user_login_state=true
        } else {
            this.oauth_user_login_state=false
        }
        return new Observable((observer)=>{
            observer.next(test);
        })
    }
}
